const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrantPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M92.4,132.6v22.5c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4v-22.5c0-5.2-4.2-9.4-9.4-9.4s-9.4,4.2-9.4,9.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1,211.9v-94.8c0-8.5,6.9-15.4,15.4-15.4h133.4c5.6,0,10.8,3.1,13.5,8l16.4-9.1c-6.1-10.9-17.5-17.6-29.9-17.6h-11.5v-34.8c0-21.7-17.7-39.4-39.4-39.4h-34.7c-21.7,0-39.4,17.7-39.4,39.4v34.8h-8.4c-18.9,0-34.2,15.3-34.2,34.2v94.8c0,18.9,15.3,34.2,34.2,34.2h87.1v-18.8H36.6c-8.5,0-15.4-6.9-15.4-15.4h0ZM63.7,48.2c0-11.4,9.3-20.6,20.6-20.6h34.7c11.4,0,20.6,9.3,20.6,20.6v34.8H63.7s0-34.8,0-34.8Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.7,162.3l-42.3-39.9c-3.8-3.6-9.7-3.4-13.3.4-1.6,1.7-2.6,4-2.6,6.4v19.8c-3.3,1.4-5.6,4.8-5.6,8.6s4.2,9.4,9.4,9.4h5.6c5.2,0,9.4-4.2,9.4-9.4v-6.6l19.4,18.4-19.4,19.6v-5.1c0-5.2-4.2-9.4-9.4-9.4h-24.4v-18.8c0-3.8-2.3-7.2-5.8-8.7-3.5-1.4-7.5-.6-10.2,2l-42.4,42.4c-1.8,1.8-2.8,4.2-2.7,6.8,0,2.5,1.1,5,3,6.7l42.4,39.8c2.7,2.6,6.7,3.3,10.1,1.8,3.4-1.5,5.7-4.9,5.7-8.6v-14.6c5.2,0,9.4-4.2,9.4-9.4s-4.2-9.4-9.4-9.4h-9.4c-5.2,0-9.4,4.2-9.4,9.4v2.3l-19.5-18.3,19.5-19.5v5.6c0,5.2,4.2,9.4,9.4,9.4h24.4v18.5c0,5.2,4.2,9.4,9.4,9.4,2.5,0,4.9-1,6.7-2.8l42.3-42.6c3.6-3.7,3.6-9.6,0-13.3,0,0-.1-.1-.2-.2Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantPermission);
export default __webpack_public_path__ + "static/media/grant-permission.6c4e9520b7c94e6f03d16194e895c887.svg";
export { ForwardRef as ReactComponent };